<ng-container *ngIf="currentTask" class="task-detail-big-container">
  <app-task-detail-header [currentTask]="currentTask"></app-task-detail-header>
  @switch (currentTask.type) {
    @case (TaskType.NEW_CUSTOMER) {
      <app-new-customer-task [currentTask]="currentTask"></app-new-customer-task>
    }
    @case (TaskType.NEW_PROPERTY) {
      <app-new-property-task [currentTask]="currentTask"></app-new-property-task>
    }
<!--    @case (TaskType.INACTIVATE_RENTAL_PROPERTY) {
      <app-inactivate-task-detail [currentTask]="currentTask"></app-inactivate-task-detail>
    }-->
    @case (TaskType.FIELD_VISIT) {
      <!-- The visit is worked on the discovery case; the task only routes it to someone. -->
      <mat-card class="field-visit">
        <p>{{ currentTask.description }}</p>
        <a mat-flat-button color="primary" [routerLink]="['/app/discovery', currentTask.relatedEntityId]">
          <mat-icon>travel_explore</mat-icon> Open discovery case
        </a>
      </mat-card>
    }
    @case (TaskType.SUSPECTED_RENTAL) {
      <mat-card class="field-visit">
        <p>{{ currentTask.description }}</p>
        @if (currentTask.status === 'OPEN') {
          <div class="task-actions">
            <button mat-flat-button color="primary" (click)="createCase()">
              <mat-icon>travel_explore</mat-icon> Create case</button>
            <a mat-stroked-button color="warn" [routerLink]="['/app/discovery', currentTask.relatedEntityId]"
               [queryParams]="{ dismiss: 1 }"><mat-icon>block</mat-icon> Dismiss</a>
          </div>
        } @else {
          <a mat-flat-button color="primary" [routerLink]="['/app/discovery', currentTask.relatedEntityId]">
            <mat-icon>travel_explore</mat-icon> Open discovery case</a>
        }
      </mat-card>
    }
    @default {
      <app-under-construction></app-under-construction>
    }
  }
</ng-container>
